import { Divider, DividerProps } from '@almbrand/divider';

export interface DividerComponentProps {
	title?: string;
	dividerType: DividerProps['dividerType'];
	margin?: DividerProps['margin'];
}

export const DividerComponent: React.FC<DividerComponentProps> = ({
	title,
	dividerType = 'primary',
	margin = 'default',
}) => {
	return (
		<Divider
			title={title}
			dividerType={dividerType}
			margin={margin}
		/>
	);
};
